// scale: 12, 14, 16, 18, 20, 24, 30, 36, 48, 60

const theme = {
  // colors: {
  //   main: '#20614F',
  //   secondary: '#518375',
  //   black: '#333',
  //   gray200: '#e9ecef',
  // },
  colors: {
    main: '#20614F',
    secondary: '#c7d6c8',
    black: '#333',
    gray200: '#e9ecef',
  },
  breakpoints: {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
}

export default theme
